import ArrowLeft from './icons/ArrowLeft'
import ArrowRight from './icons/ArrowRight'
import CalendarOutline from './icons/CalendarOutline'
import Check from './icons/Check'
import ChevronLeft from './icons/ChevronLeft'
import ChevronRight from './icons/ChevronRight'
import Collapse from './icons/Collapse'
import CopyOutline from './icons/CopyOutline'
import DiscoverOutline from './icons/DiscoverOutline'
import DiscoverSolid from './icons/DiscoverSolid'
import Expand from './icons/Expand'
import EyeClose from './icons/EyeClose'
import EyeOpen from './icons/EyeOpen'
import GameOutline from './icons/GameOutline'
import GameSolid from './icons/GameSolid'
import GearOutline from './icons/GearOutline'
import GridView from './icons/GridView'
import InformationOutline from './icons/InformationOutline'
import ListView from './icons/ListView'
import LockLocked from './icons/LockLocked'
import LockUnlocked from './icons/LockUnlocked'
import NoctuaGoldOutline from './icons/NoctuaGoldOutline'
import NoctuaGoldSolid from './icons/NoctuaGoldSolid'
import PlayOutline from './icons/PlayOutline'
import RewardOutline from './icons/RewardOutline'
import RewardSolid from './icons/RewardSolid'
import SearchOutline from './icons/SearchOutline'

export type IconName =
  | 'game'
  | 'game-active'
  | 'user'
  | 'user-circle'
  | 'gear'
  | 'copy'
  | 'arrow-left'
  | 'arrow-right'
  | 'chevron-right'
  | 'chevron-left'
  | 'check'
  | 'discover'
  | 'discover-active'
  | 'reward'
  | 'reward-active'
  | 'gold'
  | 'gold-active'
  | 'grid-view'
  | 'list-view'
  | 'calendar'
  | 'info'
  | 'eye-open'
  | 'eye-close'
  | 'lock-locked'
  | 'lock-unlocked'
  | 'search'
  | 'play'
  | 'expand'
  | 'collapse'
export interface IIcon {
  name: IconName
  size?: number
  color?: string
}
export default function Icon({
  name,
  size = 24,
  color = '#FAFAFA',
}: {
  name: IconName
  size?: number
  color?: string
}) {
  switch (name) {
    case 'game':
      return <GameOutline size={size} color={color} />
    case 'game-active':
      return <GameSolid size={size} color={color} />
    case 'gear':
      return <GearOutline size={size} color={color} />
    case 'copy':
      return <CopyOutline size={size} color={color} />
    case 'arrow-left':
      return <ArrowLeft size={size} color={color} />
    case 'arrow-right':
      return <ArrowRight size={size} color={color} />
    case 'chevron-right':
      return <ChevronRight size={size} color={color} />
    case 'chevron-left':
      return <ChevronLeft size={size} color={color} />
    case 'check':
      return <Check size={size} color={color} />
    case 'discover':
      return <DiscoverOutline size={size} color={color} />
    case 'discover-active':
      return <DiscoverSolid size={size} color={color} />
    case 'reward':
      return <RewardOutline size={size} color={color} />
    case 'reward-active':
      return <RewardSolid size={size} color={color} />
    case 'gold':
      return <NoctuaGoldOutline size={size} color={color} />
    case 'gold-active':
      return <NoctuaGoldSolid size={size} color={color} />
    case 'grid-view':
      return <GridView size={size} color={color} />
    case 'list-view':
      return <ListView size={size} color={color} />
    case 'calendar':
      return <CalendarOutline size={size} color={color} />
    case 'info':
      return <InformationOutline size={size} color={color} />
    case 'eye-open':
      return <EyeOpen size={size} color={color} />
    case 'eye-close':
      return <EyeClose size={size} color={color} />
    case 'lock-locked':
      return <LockLocked size={size} color={color} />
    case 'lock-unlocked':
      return <LockUnlocked size={size} color={color} />
    case 'search':
      return <SearchOutline size={size} color={color} />
    case 'play':
      return <PlayOutline size={size} color={color} />
    case 'expand':
      return <Expand size={size} color={color} />
    case 'collapse':
      return <Collapse size={size} color={color} />
  }
}
